export default {
  id: 172,
  title: 'Target #172 - Crossbones',
  url: 'https://cssbattle.dev/play/172',
  colors: ['#EFEB99', '#8647E6'],
  solution:
    '<a a><a b><a c><style>a[a],a[b]{height:190;top:55;left:185;width:30}a[a],a[b],a[c]{width:30}body{background:#efeb99}a{position:fixed;background:#8647e6}a[a]{rotate:45deg}a[b]{rotate:-45deg}a[c]{height:30;border-radius:50%;top:57;left:128.5;box-shadow:113px 0 #8647e6,-21px 21.5px #8647e6,134px 21.5px #8647e6,-21px 134.5px #8647e6,134px 134.5px #8647e6,0 155.5px #8647e6,113px 155.5px #8647e6}</style>',
}
